export enum ClaimRecipientContacted {
    YES = 'yes',
    NO = 'no',
    NOT_AVAILABLE = 'n/a',
}
